import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";

// Pose la classe `capacitor-native` sur <html> uniquement dans l'app packagee
// (jamais sur le site web) : sert de crochet CSS pour les quelques reglages
// qui doivent differer entre les deux, comme la reserve de bas de
// `.bottom-nav-bar` pour le bouton scanner (cf. App.css).
export function useNativePlatformClass() {
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      document.documentElement.classList.add("capacitor-native");
    }
  }, []);
}
